<template>
   <div>
      <div class="row">
         <!-- Start col -->
         <div class="col-md-12 col-lg-12 col-xl-12">
            <div class="text-center mt-1 mb-2">
            </div>
         </div>
         <!-- End col -->
      </div>

      <div class="row">
         <div class="col-12">
            <div class="card m-b-30">
               <div class="card-header">
                  <h5 class="card-title">Lista de productos disponibles</h5>
               </div>
               <div class="card-body pt-0">
                  <div class="row align-items-center ecommerce-sortby mb-2">
                     <div class="col-6 col-md-4 col-lg-3 col-xl-3 mt-3">
                        <label>Mostrar por página</label>
                        <select class="form-control form-control-mid" v-model="currentItems">
                           <option value="10">10</option>
                           <option value="15">15</option>
                           <option value="20">20</option>
                           <option value="25">25</option>
                        </select>
                     </div>
                     <div class="col-6 col-md-6 col-lg-3 col-xl-3 mt-3">
                        <label>Ordenar por</label>
                        <select class="form-control form-control-mid" v-model="currentOrder">
                           <option value="none">--</option>
                           <option value="low_price">Menor a mayor precio</option>
                           <option value="high_price">Mayor a menor precio</option>
                           <option value="stock">Más disponibles</option>
                        </select>
                     </div>

                     <div class="col-12 col-md-12 col-lg-6 col-xl-6 mt-3">
                        <label>Búsqueda</label>
                        <div class="input-group">
                           <input type="text" v-on:keyup.enter="searchProducts" class="form-control form-control-mid" v-model="currentTerm" name="inputSearch" id="inputSearch" placeholder="Ingrese un término">
                           <div class="input-group-append">
                              <button class="btn btn-outline-secondary" type="button" v-if="currentTermNotEmpty" @click="cleanSearch" ><i class="feather icon-x"></i></button>
                              <button class="btn btn-info" type="button" id="button-addon1" @click="searchProducts" :disabled="!currentTermNotEmpty" >Buscar</button>
                           </div>
                        </div>
                    </div>
                  </div>

                  <div class="card mb-2">
                     <div class="card-body ecommerce-pagination py-3 px-0">
                        <div class="row align-items-center">
                           <div class="col-lg-12 col-xl-6">
                              <p>Mostrando {{paginator.from }} a {{paginator.to}} de {{paginator.total_items}} elementos</p>
                           </div>
                           <div class="col-lg-12 col-xl-6">
                              <nav aria-label="Page navigation example">
                                 <ul class="pagination mb-0">
                                    <li class="page-item" :class="prevBtnClass"><span class="page-link" @click="loadPrevPage"><i class="feather icon-chevron-left"></i></span></li>
                                    <li v-for="(p, index) in getPagesToDisplay" :key="index" class="page-item" :class="pageBtnClass(p.page)" >
                                       <span class="page-link" @click="loadPage(p.page)">{{p.name}}</span>
                                    </li>
                                    <li class="page-item" :class="nextBtnClass"><span class="page-link" @click="loadNextPage"><i class="feather icon-chevron-right"></i></span></li>
                                 </ul>
                              </nav>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div class="row">
                     <product-card v-for="(product, index) in products" :key="index" :product="product"  @on-cart-action="onProductCartAction" />
                  </div>

                  <div class="card mb-2">
                     <div class="card-body ecommerce-pagination py-2 px-0">
                        <div class="row align-items-center">
                           <div class="col-lg-12 col-xl-6">
                              <p>Mostrando {{paginator.from }} a {{paginator.to}} de {{paginator.total_items}} elementos</p>
                           </div>
                           <div class="col-lg-12 col-xl-6">
                              <nav aria-label="Page navigation example">
                                 <ul class="pagination mb-0">
                                    <li class="page-item" :class="prevBtnClass"><span class="page-link" @click="loadPrevPage"><i class="feather icon-chevron-left"></i></span></li>
                                    <li v-for="(p, index) in getPagesToDisplay" :key="index" class="page-item" :class="pageBtnClass(p.page)" >
                                       <span class="page-link" @click="loadPage(p.page)">{{p.name}}</span>
                                    </li>
                                    <li class="page-item" :class="nextBtnClass"><span class="page-link" @click="loadNextPage"><i class="feather icon-chevron-right"></i></span></li>
                                 </ul>
                              </nav>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <product-prompt
         :product="currentProduct"
         :initial-pieces="initialPieces"
         :on-edit-mode="isOnEdit"
         :showSaveAndContinueBtn="true"
         :showSaveAndActionBtn="true"
         @on-save-product-and-continue="onAddProductAndContinue"
         @on-save-product-and-action="onAddProductAndGoToCart" />

   </div>
</template>

<script>
import ProductCard from "@components/clients/ProductCard.vue"
import ProductPrompt from "@components/clients/ProductPrompt.vue"
import {Product} from "@classes/product"
import formatHelper from "@mixins/formatHelper"
import cartHelper from "@mixins/cartHelper"
import {mapMutations, mapGetters} from "vuex";

export default {
   components: { ProductCard,ProductPrompt },
   mixins: [formatHelper, cartHelper],
   data() {
      return {
         products: [],
         activePrompt: false,
         currentProductId: null,
         currentProduct: null,
         currentPage: 1,
         currentItems: 10,
         currentOrder: "none",
         currentTerm: null,
         queryParams: {
            page: null,
            items: null,
            order: null,  
            term: null,
         },
         paginator: {
            total_items: null,
            total_pages: null,
            items_per_page: null,
            current_page: 1,
            from: null,
            to: null,
         },

         initialPieces: 1,
         isOnEdit: false,
      }
   },
   async mounted(){
      await this.reloadProductsList();
   },
   watch: {
      async currentItems(n,o){
         this.currentPage = 1
         await this.reloadProductsList()
      },
      async currentOrder(n,o){
         this.currentPage = 1
         await this.reloadProductsList()
      },
   },
   computed: {
      ...mapGetters("cart", ["getCurrentOrderDetails"]),
      prevBtnClass(){
         return (this.paginator.total_pages > 1 && this.currentPage > 1) ? "page-btn-active" : "disabled"
      },
      nextBtnClass(){
         return (this.paginator.total_pages > 1 && this.currentPage < this.paginator.total_pages) ? "page-btn-active" : "disabled"
      },
      getPagesToDisplay(){
         const total_pages = this.paginator.total_pages;
         const page = this.currentPage;
         if(total_pages < 1){
            return [];
         }
         let pages = [];
         if(total_pages > 6){
            let min = Math.max(2, (page -2));
            let max = Math.min((total_pages -1), (page +2));
            pages.push({page: 1, name: "1"});
            if(min > 2){
               pages.push({page: 0, name: "..."});
            }
            for (let index = min; index <= max; index++) {
               pages.push({page: index, name: index});
            }
            if(max < (total_pages -1)){
               pages.push({page: 0, name: "..."});
            }
            pages.push({page: total_pages, name: total_pages});
         }
         else {
            for (let index = 1; index <= total_pages; index++) {
               pages.push({page: index, name: index});
            }
         }
         return pages;
      },
      currentTermNotEmpty(){
         return this.currentTerm && this.currentTerm.trim();
      }
   },
   methods: {
      ...mapMutations("cart", ["addOrUpdateOrderDetail", "updateAmounts"]),
      async reloadProductsList(){
         this.queryParams.page = this.currentPage;
         this.queryParams.items = this.currentItems;
         this.queryParams.order = this.currentOrder;
         this.queryParams.term = this.currentTerm;
         await this.getProductsList();
      },
      async getProductsList(){
         this.showLoader("Obteniendo productos...")
         const params = this.setQueryParams()
         let url = `/stock_para_venta?${params}`;
         const res = await this.xget(url);
         if(res.success){
            this.setProducts(res.data.products);
            this.paginator = res.data.paginator;
         }
         this.stopLoader()
      },
      async searchProducts(){
         if(this.currentTermNotEmpty){
            this.currentPage = 1;
            this.reloadProductsList();
         }
      },
      async cleanSearch(){
         this.currentTerm = null;
         if(this.currentTerm != this.queryParams.term){
            this.currentPage = 1;
            this.reloadProductsList();
         }
      },
      async loadFirstPage(){
         if(this.currentPage > 1){
            this.currentPage = 1
            await this.reloadProductsList()
         }
      },
      async loadPrevPage(){
         if(this.currentPage > 1){
            this.currentPage -= 1
            await this.reloadProductsList()
         }
      },
      async loadNextPage(){
         if(this.currentPage < this.paginator.total_pages){
            this.currentPage += 1
            await this.reloadProductsList()
         }
      },
      async loadLastPage(){
         if(this.currentPage < this.paginator.total_pages){
            this.currentPage = this.paginator.total_pages
            await this.reloadProductsList()
         }
      },
      async loadPage(page){
         if(this.currentPage != page && page != 0){
            this.currentPage = page
            await this.reloadProductsList()
         }
      },
      setQueryParams(){
         const pp = this.queryParams
         let params = ""
         params += (pp.page ? `page=${pp.page}` : "")
         params += (pp.items ? `&items=${pp.items}` : "")
         params += (pp.order ? `&order=${pp.order}` : "")
         params += (pp.term ? `&term=${pp.term}` : "")
         return params
      },
      setProducts(rawProducts){
         this.products = [];
         rawProducts.forEach(prod => {
  
            let existing = this.getCurrentOrderDetails.find(f => f.product_id === prod.id_producto)
         
            this.products.push(Product.fromServiceProduct(prod));
         });
      },
      async onProductCartAction(id){
         // verificar si el producto ya ha sido cargado
         let existing = this.getCurrentOrderDetails.find(f => f.product_id === id)
         this.initialPieces = (existing ? parseInt(existing.pieces) : 1)
         this.isOnEdit = (existing != null)
         this.currentProductId = id
         this.currentProduct = this.products.find(f => f.id === id)
         this.openPrompt()
      },
      setOrderDetailToState(pieces){
         const det = this.setOrderDetail(this.currentProduct, pieces)
         this.addOrUpdateOrderDetail(det);
         const amounts = this.calculateTotalAmounts(this.getCurrentOrderDetails)
         this.updateAmounts(amounts);
      },
      pageBtnClass(page){
         if(page === 0){
            return "page-btn-unselectable";
         }
         else {
            return (this.currentPage === page) ? "page-btn-selected" : "page-btn-active";
         }
      },
      async onAddProductAndContinue(pieces){
         this.setOrderDetailToState(pieces)
         this.closePrompt()
      },
      async onAddProductAndGoToCart(pieces){
         this.setOrderDetailToState(pieces)
         this.closePrompt()
         await this.$router.push({name: "cart"})
      },
      openPrompt(){
         this.$store.commit("TOGGLE_IS_PRODUCT_PROMPT_POPUP_ACTIVE", true);
      },
      closePrompt(){
         this.$store.commit("TOGGLE_IS_PRODUCT_PROMPT_POPUP_ACTIVE", false);
      }
   }
}
</script>